//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Model from "@/models/login";
import md5 from "md5";
import BaseUrl from "@/config/baseUrl";
import { setInterval, clearInterval } from "timers";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      formData: {
        username: "",
        code: "",
        password: ""
      },
      imgUrl: "",
      show_num: [],
      sendState: false,
      sendMsg: "获取验证码"
    };
  },
  methods: {
    ...mapActions("user", {
      setUser: "setUserAction"
    }),
    // async getCode(){
    //     if(!/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[0-9])\d{8}$/.test(this.formData.username)){
    //         this.$layer.msg('输入手机号码不正确  ！请重新输入')
    //     }else if(!this.sendState){
    //         this.sendTime();
    //         this.sendState=true;
    //         let { data } = await Model.getCode({username:this.formData.username})
    //     }
    // },
    async login() {
      if (!/^.{11}$/.test(this.formData.username)) {
        this.$layer.msg("输入手机号码不正确  ！请重新输入");
        return;
      }
      if (
        this.formData.code.toLowerCase() != this.show_num.join("").toLowerCase()
      ) {
        this.$layer.msg("验证码不一致，请重新输入");
        this.draw();
        this.formData.code = "";
        return;
      }
      let { data } = await Model.login({
        ...this.formData,
        password: md5(this.formData.password)
      });
      if (data.success) {
        this.setUser(data.list);
        // sessionStorage['user']=JSON.stringify(data.list);
        localStorage["access_token"] = data.list.token;
        this.$router.push("/add");
      }
    },
    sendTime() {
      let time = 60;
      let interval = setInterval(() => {
        if (time > 1) {
          time--;
          this.sendMsg = `${time}后重新获取`;
        } else {
          this.sendMsg = "获取验证码";
          this.sendState = false;
          clearInterval(interval);
        }
      }, 1000);
    },
    draw() {
      let canvas = this.$refs.codeCanvas; //获取到canvas的对象，演员
      let canvas_width = 110;
      let canvas_height = 38;
      let context = canvas.getContext("2d"); //获取到canvas画图的环境，演员表演的舞台
      canvas.width = canvas_width;
      canvas.height = canvas_height;
      let sCode = "1,2,3,4,5,6,7,8,9,0";
      let aCode = sCode.split(",");
      let aLength = aCode.length; //获取到数组的长度

      for (let i = 0; i <= 3; i++) {
        let j = Math.floor(Math.random() * aLength); //获取到随机的索引值
        let deg = (Math.random() * 30 * Math.PI) / 180; //产生0~30之间的随机弧度
        let txt = aCode[j]; //得到随机的一个内容
        this.show_num[i] = txt;
        let x = 10 + i * 20; //文字在canvas上的x坐标
        let y = 30; //文字在canvas上的y坐标
        context.font = "bold 38px 微软雅黑";

        context.translate(x, y);
        // context.rotate(deg);

        context.fillStyle = this.randomColor();
        context.fillText(txt, 0, 0);

        // context.rotate(-deg);
        context.translate(-x, -y);
      }
      // for (let i = 0; i <= 5; i++) { //验证码上显示线条
      //     context.strokeStyle = this.randomColor();
      //     context.beginPath();
      //     context.moveTo(Math.random() * canvas_width, Math.random() * canvas_height);
      //     context.lineTo(Math.random() * canvas_width, Math.random() * canvas_height);
      //     context.stroke();
      // }
      for (let i = 0; i <= 30; i++) {
        //验证码上显示小点
        context.strokeStyle = this.randomColor();
        context.beginPath();
        let x = Math.random() * canvas_width;
        let y = Math.random() * canvas_height;
        context.moveTo(x, y);
        context.lineTo(x + 1, y + 1);
        context.stroke();
      }
      this.imgUrl = canvas.toDataURL("image/png");
    },
    randomColor() {
      //得到随机的颜色值
      let r = Math.floor(Math.random() * 256);
      let g = Math.floor(Math.random() * 256);
      let b = Math.floor(Math.random() * 256);
      return "rgb(" + r + "," + g + "," + b + ")";
    }
  },
  mounted() {
    this.draw();
  },
  created() {
    localStorage.removeItem("access_token");
  }
};



// WEBPACK FOOTER //
// ./src/pages/login/view.vue